"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var QliconiconFangxiangXia1Filled = { "icon": { "tag": "svg", "attrs": { "aria-hidden": "true", "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M128 341.33h85.33L512 640l298.67-298.67H896l-384 384-384-384z" } }] }, "name": "qliconicon_fangxiang_xia1", "theme": "filled" };
exports.default = QliconiconFangxiangXia1Filled;
